import { FormatNumberOptions, useIntl } from 'react-intl';

export type CurrencyFormatProps = {
  value?: string | number;
  symbol?: string;
  currency?: string;
} & FormatNumberOptions;

const isValidValue = (value?: string | number) => typeof value !== 'undefined';
const useCurrencyFormat = ({
  value,
  symbol,
  currency,
  ...formatOptions
}: CurrencyFormatProps) => {
  const { formatNumber } = useIntl();
  if (!isValidValue(value)) return '';

  if (isValidValue(value) && currency) {
    const val = formatNumber(Number(value), { currency, ...formatOptions });
    return `${val} ${currency}`;
  }

  const formattedValue = formatNumber(Number(value));
  return symbol ? `${symbol} ${formattedValue}` : formattedValue;
};

export default useCurrencyFormat;
